import { useCallback, useState } from 'react';

import type { TFunction } from '@adsk/alloy-react-localization';

import { useTranslation } from '../i18n';

const getPlaceholder = ({
  t,
  hasTokens,
  showSearch,
  placeholderOverride,
}: {
  t: TFunction;
  hasTokens?: boolean;
  showSearch?: boolean;
  placeholderOverride?: string;
}) => {
  if (hasTokens) {
    // Token controls with tokens should not show placeholders
    return '';
  }

  if (placeholderOverride) {
    return placeholderOverride;
  }

  return showSearch ? t('SEARCH') : t('SELECT');
};

export default ({
  placeholderProp,
  hasTokens,
  isOpen,
  disabled,
  openMenu,
}: {
  placeholderProp: string | undefined;
  hasTokens?: boolean;
  isOpen: boolean;
  disabled: boolean | undefined;
  openMenu: (() => void) | undefined;
}) => {
  const { t } = useTranslation();
  const [isInputFocused, setIsInputFocused] = useState(false);

  const placeholder = getPlaceholder({
    t,
    hasTokens,
    showSearch: isOpen || isInputFocused,
    placeholderOverride: placeholderProp,
  });

  const onFocus = useCallback(() => setIsInputFocused(true), []);
  const onBlur = useCallback(() => setIsInputFocused(false), []);

  const onContainerClick = useCallback(() => {
    !isOpen && !disabled && openMenu?.();
  }, [disabled, isOpen, openMenu]);

  return {
    containerProps: {
      isOpen,
      isAutocomplete: true,
      disabled,
      onClick: onContainerClick,
    },
    searchInputProps: {
      isOpen,
      disabled,
      placeholder,
      onFocus,
      onBlur,
      showIcon: !hasTokens && (isOpen || isInputFocused),
    },
  };
};
